import React, { useContext } from "react";
import { UserContext } from "../Context/UserContext";

export default function MyTextarea(props) {
    const {label, className, type, value, onChange, name, onBlur, onFocus, mendatory} = props;
    const {darkTheme} = useContext(UserContext);
  return (
    <div className="text-sm mb-1">
      <label>{label} <span className="text-red-500 font-bold">{mendatory}</span></label>
      <textarea {...props} onBlur={onBlur} onFocus={onFocus} name={name} type={type} value={value} onChange={onChange} className={`border rounded-lg outline-none uppercase py-[8px] px-3 ${className} ${darkTheme? "bg-gray-700 border-gray-500" : "border-gray-500 bg-[#ffff]"}`} rows={1} />
    </div>
  );
}
